var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgMoney",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgMoney{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money",
    className: "svgMoney svgBase svgHover svgSelect",
    d: "M16.4,4.8h1.1v10.1c0,0.6-0.5,1.1-1.1,1.1l0,0H3.7v-1.1h12.7V4.8L16.4,4.8z M15.4,12.7 c0,0.6-0.5,1.1-1.1,1.1l0,0H1.6c-0.6,0-1.1-0.5-1.1-1.1l0,0V3.2c0-0.6,0.5-1.1,1.1-1.1h0h12.7c0.6,0,1.1,0.5,1.1,1.1l0,0L15.4,12.7z  M1.6,3.2v9.5h12.7V3.2H1.6z M7.9,10.8c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8l0,0C10.8,9.5,9.5,10.8,7.9,10.8z  M7.9,6.2c-1,0-1.8,0.8-1.8,1.7s0.8,1.8,1.7,1.8c1,0,1.8-0.8,1.8-1.7c0,0,0,0,0,0C9.7,7,8.9,6.2,7.9,6.2L7.9,6.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.387ac7cc.svg";
export { ForwardRef as ReactComponent };